import { vanillaStyles } from '@jsonforms/vanilla-renderers';

// Adds custom classNames for components/controls in JSON forms.

export const JSONFormStyles = {
  styles: [
    ...vanillaStyles,
    {
      name: 'categorization.master',
      classNames: ['flex', 'flex-col', 'gap-2'],
    },
    {
      name: 'category.subcategories',
      classNames: ['flex', 'justify-between', 'px-8', 'pb-1'],
    },
    {
      // The vanilla VerticalLayout renderer is the outermost container of every
      // schema-driven form (each one roots at a VerticalLayout), so it is the
      // JSON-form counterpart of `FormLayout` and carries the same contract:
      // `mx-auto flex w-full flex-col gap-5 text-left`. The previous `w-4/5`
      // squeezed every JSON form to 80% of its host, `gap-6` stacked fields at
      // 24px instead of the shared 20px rhythm, and `pb-10` reserved footer
      // space that the surrounding wizard/dialog footer already owns.
      // `items-left` is not a Tailwind class and emitted no CSS at all.
      name: 'vertical.layout',
      classNames: [
        'flex',
        'flex-col',
        'gap-5',
        'w-full',
        'mx-auto',
        'text-left',
        'bg-white',
        'text-content-primary',
        'leading-relaxed',
      ],
    },
    {
      name: 'group.layout',
      classNames: ['pt-6'],
    },
  ],
};
